import { render, staticRenderFns } from "./join.vue?vue&type=template&id=fa4ada56&scoped=true&"
import script from "./join.vue?vue&type=script&lang=js&"
export * from "./join.vue?vue&type=script&lang=js&"
import style0 from "./join.vue?vue&type=style&index=0&id=fa4ada56&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4ada56",
  null
  
)

export default component.exports